import React from 'react'

export default class Waveform extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      waveformData: this.sampleData(props.data)
    }

    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.setCanvasContainerRef = this.setCanvasContainerRef.bind(this)
    this.setCanvasRef = this.setCanvasRef.bind(this)
  }

  componentDidMount() {
    this.updateWaveform()
    window.addEventListener('resize', this.handleWindowResize, true)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize, true)
  }

  handleWindowResize() {
    if (this.canvasElement) {
      this.canvasElement.style.width = `${this.canvasContainerElement.parentNode
        .clientWidth}px`
    }
  }

  sampleData(response) {
    let form = { max: 1, samples: [] }
    for (let i = 0; i < response.length; i++) {
      const sample = response.data[i * 2 + 1] - response.data[i * 2]
      form.samples.push(sample)
      if (sample > form.max) {
        form.max = sample
      }
    }
    return form
  }

  updateWaveform() {
    const { colour } = this.props
    const { waveformData } = this.state
    const canvasContainer = this.canvasContainerElement
    const canvas = this.canvasElement

    const context = canvas.getContext('2d')
    canvas.style.width = `${canvasContainer.parentNode.clientWidth}px`
    canvas.width = this.state.waveformData.samples.length

    // Clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height)

    // Pre-calculate some values
    const yBaseline = canvas.height / 2
    const yMultiplier = yBaseline / waveformData.max

    // Draw the dividing middle line
    context.lineWidth = 0.1
    context.beginPath()
    context.moveTo(0, yBaseline)
    context.lineTo(canvas.width, yBaseline)
    context.stroke()

    // Draw the top part of the waveform
    context.fillStyle = colour
    context.beginPath()
    context.moveTo(0, yBaseline)
    for (let i = 0; i < waveformData.samples.length; i++) {
      context.lineTo(i, yBaseline - waveformData.samples[i] * yMultiplier)
    }
    context.lineTo(canvas.width, yBaseline)
    context.closePath()
    context.fill()

    // Draw the bottom part
    context.beginPath()
    context.moveTo(0, yBaseline)
    for (let i = 0; i < waveformData.samples.length; i++) {
      context.lineTo(i, yBaseline + waveformData.samples[i] * yMultiplier)
    }
    context.lineTo(canvas.width, yBaseline)
    context.closePath()
    context.fill()
  }

  setCanvasContainerRef(canvasContainerElement) {
    this.canvasContainerElement = canvasContainerElement
  }

  setCanvasRef(canvasElement) {
    this.canvasElement = canvasElement
  }

  render() {
    const { progress } = this.props
    const canvasContainerStyles = {
      width: `${progress * 100}%`,
      height: '100%',
      position: 'absolute',
      overflow: 'hidden'
    }
    const canvasStyles = {
      height: '100%',
      position: 'absolute'
    }
    return (
      <div ref={this.setCanvasContainerRef} style={canvasContainerStyles}>
        <canvas ref={this.setCanvasRef} style={canvasStyles} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/audio/waveform.js